import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_receive_data_4011Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { field_to_update: string, warehouse_name: string }): Promise<{ reason?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.field_to_update)) {
      $missingRequiredInParams.push('\'field_to_update\'');
    }
    if (isNil($inParams.warehouse_name)) {
      $missingRequiredInParams.push('\'warehouse_name\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/functions/receive_data_4011`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

